<template>
	<li @click="eqInfo.airVentilator.systemStatus1 === '0' ? eqStart() : shutDown()" class="eqSwitchMachine" :class="eqInfo.airVentilator.systemStatus1 !== '0' ? 'li-open2' : 'li-open'">
		<span></span>
    {{
      eqInfo.airVentilator.systemStatus1 === '0' ? '开机' :
          eqInfo.airVentilator.systemStatus1 === '1' ? '开机' :
              eqInfo.airVentilator.systemStatus1 === '2' ? '开机' :
                  eqInfo.airVentilator.systemStatus1 === '3' ? '开机' :
                      eqInfo.airVentilator.systemStatus1 === '4' ? '关机' :
                          eqInfo.airVentilator.systemStatus1 === '5' ? '关机' :
                              eqInfo.airVentilator.systemStatus1 === '6' ? '关机' :
                                  eqInfo.airVentilator.systemStatus1 === '7' ? '开机' :
                                      eqInfo.airVentilator.systemStatus1 === '8' ? '开机' :
                                          eqInfo.airVentilator.systemStatus1 === '9' ? '开机' : '关机'
    }}
		<!--        关机提示-->
		<div class="tip detail_tip" v-show="closeTip">
			<div class="content">
				<div class="tip_body closeTip_body">
					<div class="modal-warning">
						<span :class="this.closeIcon"></span>
						<p>{{ this.closeText }}</p>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>
<script>
import { Range, Toast, Popup, Radio, Indicator } from 'mint-ui';

export default {
	name: 'eqSwitchMachine',
	props: ['eqInfo', 'id'],
	data() {
		return {
			closeTip: false,
			strike: true,
			closeText: '关机中...',
			closeIcon: 'icon-loading-off'
		};
	},
	methods: {
		getId() {
			return this.id;
		},
		closeInterval(flag) {
			this.closeTip = true;
			this.strike = false;
			let type = '关机';
			this.closeIcon = 'icon-loading-off';
			if (flag == 1) {
				type = '开机';
				this.closeIcon = 'icon-loading-on';
			}
			let time = 120;
			this.closeText = type + '中 ' + time + '秒';
			this.closeTimer = setInterval(() => {
				time--;
				this.closeText = type + '中 ' + time + '秒';
				if (time <= 0) {
					this.strike = true;
					this.closeTip = false;
					clearInterval(this.closeTimer);
					Toast(type + '成功');
					this.$emit('init');
				}
			}, 1000);
		},
		eqStart() {
			if (this.strike) {
        let data = {
          "iotDeviceId" : parseInt(this.getId())
        }
				this.Api.freshStartUp(data, (msg) => {
					if (msg.code === 200) {
						this.closeInterval(1);
					} else {
						Toast(msg.message);
					}
				});
			}
		},
		shutDown() {
			if (this.strike) {
        let data = {
          "iotDeviceId" : parseInt(this.getId())
        }
				this.Api.freshShutDown(data, (msg) => {
					if (msg.code === 200) {
						this.closeInterval();
					} else {
						Toast(msg.message);
					}
				});
			}
		}
	}
};
</script>

<style scoped>
@import 'index.css';
</style>



// WEBPACK FOOTER //
// src/components/commen/eqSwitchMachine/index.vue